module.exports = __webpack_public_path__ + "img/Cc.09456505.png";